import {
  DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL,
  VariableComplexityPolicyModel,
} from '../model';
import { VariableComplexityPolicyDto } from './types';

export function fromVariableComplexityPolicyDto(
  dto: VariableComplexityPolicyDto,
): VariableComplexityPolicyModel {
  return {
    targetCardinalityThreshold: Number(
      dto?.target_cardinality_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.targetCardinalityThreshold,
    ),
    valueSizeThreshold: Number(
      dto?.value_size_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.valueSizeThreshold,
    ),
    valueKeysThreshold: Number(
      dto?.value_keys_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.valueKeysThreshold,
    ),
    valueDepthThreshold: Number(
      dto?.value_depth_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.valueDepthThreshold,
    ),
    constraintOperatorsThreshold: Number(
      dto?.constraint_operators_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.constraintOperatorsThreshold,
    ),
    constraintGroupsThreshold: Number(
      dto?.constraint_groups_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.constraintGroupsThreshold,
    ),
    changeFrequencyThreshold: Number(
      dto?.change_frequency_threshold ??
        DEFAULT_VARIABLE_COMPLEXITY_POLICY_MODEL.changeFrequencyThreshold,
    ),
  };
}

export function toVariableComplexityPolicyDto(
  model: VariableComplexityPolicyModel,
): VariableComplexityPolicyDto {
  return {
    target_cardinality_threshold: model.targetCardinalityThreshold,
    value_size_threshold: model.valueSizeThreshold,
    value_keys_threshold: model.valueKeysThreshold,
    value_depth_threshold: model.valueDepthThreshold,
    constraint_operators_threshold: model.constraintOperatorsThreshold,
    constraint_groups_threshold: model.constraintGroupsThreshold,
    change_frequency_threshold: model.changeFrequencyThreshold,
  };
}
